import { ParamTextElement } from '../../slateTypes';

function paramTextSerializer(paramElement: ParamTextElement) {
  const { type, label } = paramElement;
  return `{{#${type}}}${encodeURIComponent(label)}{{/${type}}}`;
}

export default paramTextSerializer;
